import React from "react";
import { HStack, Select, Text, useSelectContext } from "@chakra-ui/react";
import AppAvatar from "components/utils/AppAvatar";
import { DashboardSelectContent, DashboardSelectItem, DashboardSelectTrigger } from "components/utils/FormControls";

function getItemValue(item) {
  if (item?.value != null) return String(item.value);
  if (item?.id != null) return String(item.id);
  return "";
}

function getItemLabel(item) {
  return item?.label ?? item?.name ?? "Item";
}

function AvatarSelectValue({ placeholder }) {
  const select = useSelectContext();
  const item = (select.selectedItems || [])[0];

  if (!item) {
    return (
      <Select.ValueText placeholder={placeholder}>
        <Text color="dashboard.fg.subtle" textAlign="left">{placeholder}</Text>
      </Select.ValueText>
    );
  }

  const label = getItemLabel(item);
  const value = getItemValue(item);
  const avatar = item?.avatar;
  const color = item?.color || item?.accentColor;

  return (
    <Select.ValueText placeholder={placeholder}>
      <HStack gap="2" w="full" justify="flex-start">
        <AppAvatar size="2xs" name={label} src={avatar} seed={value || label} color={color} />
        <Text flex="1" textAlign="left">{label}</Text>
      </HStack>
    </Select.ValueText>
  );
}

export function AvatarSelectField({
  collection,
  value,
  onChange,
  placeholder = "Selecciona...",
  size = "sm",
  positioning = { strategy: "fixed", hideWhenDetached: true },
}) {
  return (
    <Select.Root
      collection={collection}
      size={size}
      value={value ? [value] : []}
      onValueChange={(event) => onChange?.(event.value?.[0] ?? "")}
      positioning={positioning}
    >
      <Select.HiddenSelect />
      <Select.Control>
        <DashboardSelectTrigger textAlign="left">
          <AvatarSelectValue placeholder={placeholder} />
        </DashboardSelectTrigger>
        <Select.IndicatorGroup>
          <Select.Indicator color="dashboard.accent.solid" />
        </Select.IndicatorGroup>
      </Select.Control>
      <Select.Positioner>
        <DashboardSelectContent>
          {collection.items.map((item) => {
            const valueKey = getItemValue(item);
            const label = getItemLabel(item);
            const avatar = item?.avatar;
            const color = item?.color || item?.accentColor;

            return (
              <DashboardSelectItem key={valueKey} item={item}>
                <AppAvatar size="2xs" name={label} src={avatar} seed={valueKey || label} color={color} />
                <Text flex="1" textAlign="left">{label}</Text>
                <Select.ItemIndicator />
              </DashboardSelectItem>
            );
          })}
        </DashboardSelectContent>
      </Select.Positioner>
    </Select.Root>
  );
}

export default AvatarSelectField;
